import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    header: {
      marginLeft: 10
    }
});

export default styles;